/**
 * LogRocket custom event names for My QIMA performance (Time Between Events).
 * @see docs/plans/logrocket-flow-timing.md
 */
export const LOGROCKET_PERF_EVENTS = {
  openBookingsViewOrderClicked: 'myqima_perf_open_bookings_view_order_clicked',
  openBookingsViewOrderLoaded: 'myqima_perf_open_bookings_view_order_loaded',
  bookInspectionOpenInAcaClicked: 'myqima_perf_book_inspection_open_in_aca_clicked',
  bookInspectionInAcaReady: 'myqima_perf_book_inspection_in_aca_ready',
  productInspectionDraftStarted: 'myqima_perf_product_inspection_draft_started',
  productInspectionDraftReady: 'myqima_perf_product_inspection_draft_ready',
  inspectionCheckoutConfirmClicked: 'myqima_perf_inspection_checkout_confirm_clicked',
  inspectionConfirmationOrderLoaded: 'myqima_perf_inspection_confirmation_order_loaded',
  reportsInspectionRowClicked: 'myqima_perf_reports_inspection_row_clicked',
  interactiveReportLoaded: 'myqima_perf_interactive_report_loaded',
  reportsLobChangeClicked: 'myqima_perf_reports_lob_change_clicked',
  reportsTableDataLoaded: 'myqima_perf_reports_table_data_loaded',
  interactiveReportAiSummaryClicked: 'myqima_perf_interactive_report_ai_summary_clicked',
  interactiveReportAiSummaryLoaded: 'myqima_perf_interactive_report_ai_summary_loaded',
  bookingImportChecklistOpened: 'myqima_perf_booking_import_checklist_opened',
  bookingImportChecklistApplied: 'myqima_perf_booking_import_checklist_applied',
  bookingChecklistOpenClicked: 'myqima_perf_booking_checklist_open_clicked',
  bookingChecklistLoaded: 'myqima_perf_booking_checklist_loaded',
  bookingChecklistSelected: 'myqima_perf_booking_checklist_selected',
  bookingChecklistApplied: 'myqima_perf_booking_checklist_applied',
  adyenCheckoutInitialized: 'myqima_perf_adyen_checkout_initialized',
} as const;

/**
 * sessionStorage keys for pending timed flows (single-flight per tab).
 */
export const LOGROCKET_PERF_SESSION_KEYS = {
  viewOrder: 'lr_perf_view_order',
  bookInspectionAcaIframe: 'lr_perf_book_inspection_aca_iframe',
  productInspectionDraft: 'lr_perf_product_inspection_draft',
  confirmInspection: 'lr_perf_confirm_inspection',
  interactiveReport: 'lr_perf_interactive_report',
  reportsLobChange: 'lr_perf_reports_lob_change',
  aiSummary: 'lr_perf_ai_summary',
  checklistImport: 'lr_perf_checklist_import',
  checklistImportModal: 'lr_perf_checklist_import_modal',
  checklistSelectApply: 'lr_perf_checklist_select_apply',
} as const;
